export default __webpack_public_path__ + "static/media/image.747b0b6c.svg";